export const BRAINTREE_SDK_HOSTED_FIELDS_FIX_VERSION = '3.128.0';
export const BRAINTREE_SDK_DEFAULT_VERSION = '3.123.2';
export const BRAINTREE_SDK_STABLE_VERSION = '3.106.0';
